import { FC } from 'react'
import type { IconProps } from '../types'

const CrossIcon: FC<IconProps> = props => {
  const { size = 10, color = '#121432' } = props

  // prettier-ignore
  return <svg width={size} height={size} viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9.24269 0.756926C8.85217 0.366401 8.29815 0.287256 8.00526 0.580149L5.00005 3.58535L1.99485 0.580149C1.70196 0.287256 1.14794 0.366401 0.757414 0.756926C0.36689 1.14745 0.287744 1.70147 0.580637 1.99436L3.58584 4.99957L0.580637 8.00477C0.287744 8.29766 0.36689 8.85168 0.757414 9.24221C1.14794 9.63273 1.70196 9.71188 1.99485 9.41898L5.00005 6.41378L8.00526 9.41898C8.29815 9.71188 8.85217 9.63273 9.24269 9.24221C9.63322 8.85168 9.71237 8.29766 9.41947 8.00477L6.41427 4.99957L9.41947 1.99436C9.71237 1.70147 9.63322 1.14745 9.24269 0.756926Z'
      fill={color}
    />
  </svg>
}

export default CrossIcon
